/**
 * ISO 639-1 language codes and conversion helpers.
 *
 * Language codes are stored as ISO 639-1 alpha-2 codes (e.g. "en", "fr")
 * in the backend and Elasticsearch. Only languages with 200+ brands in the
 * database are included in the filter dropdown.
 */

export enum Language {
  en = "en",
  es = "es",
  de = "de",
  fr = "fr",
  it = "it",
  ja = "ja",
  pt = "pt",
  nl = "nl",
  tr = "tr",
  sv = "sv",
  ar = "ar",
  ko = "ko",
  zh = "zh",
  fi = "fi",
  pl = "pl",
  id = "id",
  da = "da",
  ru = "ru",
  cs = "cs",
  el = "el",
  ro = "ro",
  th = "th",
  ca = "ca",
  vi = "vi",
  no = "no",
  uk = "uk",
  hi = "hi",
  he = "he",
  lt = "lt",
  sr = "sr",
  bg = "bg",
  hu = "hu",
  sl = "sl",
  sk = "sk",
  hr = "hr",
  tl = "tl",
  et = "et",
  ms = "ms",
}

const LANGUAGE_CODE_TO_NAME: { [key: string]: string } = {
  [Language.en]: "English",
  [Language.es]: "Spanish",
  [Language.de]: "German",
  [Language.fr]: "French",
  [Language.it]: "Italian",
  [Language.ja]: "Japanese",
  [Language.pt]: "Portuguese",
  [Language.nl]: "Dutch",
  [Language.tr]: "Turkish",
  [Language.sv]: "Swedish",
  [Language.ar]: "Arabic",
  [Language.ko]: "Korean",
  [Language.zh]: "Chinese",
  [Language.fi]: "Finnish",
  [Language.pl]: "Polish",
  [Language.id]: "Indonesian",
  [Language.da]: "Danish",
  [Language.ru]: "Russian",
  [Language.cs]: "Czech",
  [Language.el]: "Greek",
  [Language.ro]: "Romanian",
  [Language.th]: "Thai",
  [Language.ca]: "Catalan",
  [Language.vi]: "Vietnamese",
  [Language.no]: "Norwegian",
  [Language.uk]: "Ukrainian",
  [Language.hi]: "Hindi",
  [Language.he]: "Hebrew",
  [Language.lt]: "Lithuanian",
  [Language.sr]: "Serbian",
  [Language.bg]: "Bulgarian",
  [Language.hu]: "Hungarian",
  [Language.sl]: "Slovenian",
  [Language.sk]: "Slovak",
  [Language.hr]: "Croatian",
  [Language.tl]: "Filipino",
  [Language.et]: "Estonian",
  [Language.ms]: "Malay",
};

export const languageCodeToName = (code: string): string =>
  LANGUAGE_CODE_TO_NAME[code] || code;

export const languageNameToCode = (name: string): string => {
  const entry = Object.entries(LANGUAGE_CODE_TO_NAME).find(
    ([, n]) => n.toLowerCase() === name.toLowerCase(),
  );
  return entry ? entry[0] : name;
};

export const LANGUAGES = Object.values(Language).map((code) => ({
  key: code,
  name: LANGUAGE_CODE_TO_NAME[code],
}));

export const LANGUAGE_DISCOVER_FILTER = Object.fromEntries(
  Object.values(Language).map((code) => [
    code,
    { name: LANGUAGE_CODE_TO_NAME[code], params: "language" },
  ]),
);
